import moment from 'moment';

export const checkIsBefore = (firstDate, secondDate) => moment(firstDate).isBefore(secondDate)